import { loadStripe } from "@stripe/stripe-js/pure";
import "./../config";
import { useSelector } from "react-redux";

// Initialize a variable to hold the Stripe.js promise.
let stripePromise;
let stripeKey;

// Create a function to get the Stripe client.
const getStripeClient = () => {
  // Get the 'auth' and 'isBookingApi' values from the Redux store.
  const auth = useSelector((state) => state.auth);
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);

  // Initialize a variable to hold the Stripe publishable key.
  let publicKey = "";

  // Determine the Stripe publishable key based on conditions.
  if (auth && auth.user) {
    const currentUser = auth.user;
    publicKey =
      currentUser && currentUser.salon && currentUser.salon.stripe_publishable_key
        ? currentUser.salon.stripe_publishable_key
        : "";
  } else if (isBookingApi) {
    publicKey =
      isBookingApi.salon && isBookingApi.salon.stripe_publishable_key
        ? isBookingApi.salon.stripe_publishable_key
        : "";
  }
  // console.log('publicKey', publicKey)
  // Assign the Stripe publishable key to a variable.
  const stripe_publishable_key = publicKey;
  const usableStripeKey = /^pk_(test|live)_[A-Za-z0-9]{24,}$/.test(stripe_publishable_key);
  // console.log('publicKey', stripe_publishable_key);

  // If the Stripe promise hasn't been initialized yet, load Stripe with the key.
  if (!usableStripeKey) return null;
  if (!stripePromise || stripeKey !== stripe_publishable_key) {
    stripeKey = stripe_publishable_key;
    stripePromise = loadStripe(stripe_publishable_key);
  }

  // Return the Stripe promise.
  return stripePromise || null;
};

export default getStripeClient;
